import { render, staticRenderFns } from "./ConfigurationDetail.vue?vue&type=template&id=97f1bd28&"
import script from "./ConfigurationDetail.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports